<template>
  <div class="wrapper">
    <button type="button" @click="abrir" class="buttonSec abrir">
      Abrir
    </button>

    <button typoe="button" @click="fechar" class="buttonSec fechar">
      fechar
    </button>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('ok')
  },
  methods: {
    async abrir() {
      const payload = {
        type: 'abrir'
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        const ret = await fetch(`https://peaceparking.app:3000/abertura/`, opts);
        const data = await ret.json();
        const isOpened = data.isOpened;
        console.log('ret', isOpened)
      } catch (error) {
        console.error(error);
      }
    },
    async fechar() {
      const payload = {
        type: 'fechar'
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        const ret = await fetch(`https://peaceparking.app:3000/abertura/`, opts);
        const data = await ret.json();
        const isOpened = data.isOpened;
        console.log('ret', isOpened)
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.buttonSec {
  width: 500px;
  height: 200px;
  color: #000;
  font-weight: bold;
  font-size: 30px;
}
.abrir {
  background-color: #0D0;
}
.fechar {
  background-color: #D00;
}
</style>
